import { CARDS_GRID_ITEM_SIZE_BY_DENSITY } from '@app/components/base/content-structure/cards-grid-config';

/** Grid breakpoints for the YouTube broadcasts list (fixed wide density). */
export const YOUTUBE_BROADCASTS_GRID_ITEM_SIZE = CARDS_GRID_ITEM_SIZE_BY_DENSITY.gridWide;

/** Number of skeleton cards shown while the broadcasts list is loading. */
export const YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT = 12;
